import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';


@Component({
	templateUrl: './404.component.html',
	styleUrls: ['./404.component.scss'],
	imports: [MatIcon, MatButton, RouterLink]
})
export class Error404Component {}
